<template>
  <div class="contact grid-2">
    <div class="map card">
      <iframe :src="map.google" title="엔케이시스템 위치 지도" loading="lazy" referrerpolicy="no-referrer-when-downgrade" allowfullscreen></iframe>
    </div>
    <div class="info">
      <h2 class="title">{{ title }}</h2>
      <dl class="list">
        <div class="row"><dt>주소</dt><dd>{{ company.address }}</dd></div>
        <div class="row"><dt>전화</dt><dd><a :href="company.phoneLink">{{ company.phone }}</a></dd></div>
        <div class="row"><dt>이메일</dt><dd><a :href="'mailto:' + company.email">{{ company.email }}</a></dd></div>
      </dl>
      <div class="actions">
        <a class="btn btn-primary" :href="'mailto:' + company.email">이메일로 문의하기</a>
        <a class="btn btn-ghost-dark btn-sm" :href="map.kakao" target="_blank" rel="noopener">카카오맵 길찾기</a>
        <a class="btn btn-ghost-dark btn-sm" :href="map.naver" target="_blank" rel="noopener">네이버지도 길찾기</a>
      </div>
    </div>
  </div>
</template>

<script>
import { company, mapLinks } from '@/data/company';

export default {
  name: 'ContactBlock',
  props: { title: { type: String, default: '오시는 길 · 문의' } },
  data() { return { company, map: mapLinks }; },
};
</script>

<style scoped>
.contact { gap: 32px; align-items: stretch; }
.map { overflow: hidden; min-height: 380px; padding: 0; }
.map iframe { width: 100%; height: 100%; min-height: 380px; border: 0; display: block; }
.info { background: var(--navy); color: #ffffff; border-radius: var(--radius); padding: 40px; display: flex; flex-direction: column; gap: 28px; }
.title { font-size: 32px; font-weight: 700; letter-spacing: -0.02em; }
.list { margin: 0; display: flex; flex-direction: column; gap: 18px; font-size: 16px; line-height: 1.6; }
.row { display: flex; gap: 16px; }
dt { flex: 0 0 64px; color: var(--on-dark); font-size: 14px; font-weight: 600; }
dd { margin: 0; }
dd a { color: #ffffff; }
dd a:hover { color: var(--orange); }
.actions { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; }
@media (max-width: 900px) {
  .info { padding: 28px; gap: 20px; }
  .title { font-size: 24px; }
  .map, .map iframe { min-height: 300px; }
}
</style>
